/**
 * Validates /:lang marketing segment and renders nested routes.
 */

import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { LOCALES } from '../i18n/localePaths';

const LocaleLayout = () => {
  const { lang } = useParams();

  if (!LOCALES.includes(lang)) {
    return <Navigate to="/es" replace />;
  }

  return <Outlet />;
};

export default LocaleLayout;
